import axios from 'axios';

const apiCallers = {},
  setApiConfig = config => {
    apiCallers[config.app] = axios.create({
      baseURL: config.api,
      headers: config.token ? { Nakvksectok: `Bearer ${config.token}`} : {}
    });

    if (config.interceptors && typeof config.interceptors.request === 'function' && typeof config.interceptors.response === 'function') {
      apiCallers[config.app].interceptors.request.use(
        function(requestConfig) {
          config.interceptors.request(requestConfig);
          return requestConfig;
        },
        function(error) {
          return Promise.reject(error);
        }
      );

      apiCallers[config.app].interceptors.response.use(
        function(response) {
          config.interceptors.response(response);
          return response;
        },
        function(error) {
          return Promise.reject(error);
        }
      );
    }
  };

export { apiCallers, setApiConfig };



// WEBPACK FOOTER //
// ./src/api/apiRequest.js